import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Video, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShowCard } from "@/components/ShowCard";
import { Loading, PageHead, Empty } from "@/components/common";

export default function MyShows() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/shows").then((d) => setShows(d.shows.filter((s) => s.seller_id === user?.user_id))).catch(() => {}).finally(() => setLoading(false));
  }, [user]);

  if (loading) return <Loading />;

  return (
    <div className="fade-up">
      <PageHead
        title="My Shows"
        sub="Manage the live shows you host."
        right={<button className="ss-btn ss-btn-primary" onClick={() => navigate("/sell")} data-testid="new-show-button"><Plus size={16} /> New show</button>}
      />
      {shows.length === 0 ? (
        <Empty icon={Video} title="You haven't hosted a show yet" sub="Start your first live show to reach buyers.">
          <button className="ss-btn ss-btn-gold" onClick={() => navigate("/sell")} data-testid="go-live-button"><Video size={16} /> Go Live</button>
        </Empty>
      ) : (
        <div className="ss-grid grid-3" data-testid="my-shows-grid">
          {shows.map((s) => <ShowCard key={s.id} show={s} />)}
        </div>
      )}
    </div>
  );
}
